<div
  [class.with-ai-rail]="aiBuilder.railMounted()"
  [class.ai-rail-outside-project]="aiBuilder.outsideProject()"
  [class.ai-rail-entering]="aiBuilder.railEntering()"
  [class.ai-rail-leaving]="aiBuilder.railLeaving()"
  [style.--ai-rail-animation.ms]="railAnimationMs"
  [style.--flx-header-height]="showHeader() ? null : '0px'"
  [attr.data-ai-rail]="aiBuilder.railMounted() ? 'mounted' : 'unmounted'"
  class="app-root-container"
  data-testId="app-root-container"
>
  <!-- One header above every authenticated page. -->
  @if (showHeader()) {
    <flx-global-header />
  }

  <div class="app-body">
    <!-- AI-assisted builder. On Make it docks as a conversation rail left of the designer, under
         the header; on Plan it takes the frame below the bars, the designer still mounted underneath. -->
    @defer (when aiBuilder.railMounted()) {
      @if (aiBuilder.railMounted()) {
        <flx-ai-builder-rail class="ai-builder-frame rail midnight" />
      }
    }

    @defer (when aiBuilder.planOpen()) {
      @if (aiBuilder.planOpen()) {
        <flx-ai-builder-plan-view class="ai-builder-frame full midnight" />
      }
    }

    <!-- Main content -->
    <div class="main-content-wrapper">
      <div
        id="overlay-root"
        class="router-wrapper"
      >
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
